/**
 * In-Memory Token Service (CWE-922 Remediation)
 * Prevents insecure persistent disk storage of JWT authorization tokens in localStorage.
 * Tokens live in volatile memory and short-lived tab session storage.
 */

let inMemoryToken: string | null = null;
let tokenChangeListeners: Array<(token: string | null) => void> = [];

export const tokenService = {
  setToken: (token: string | null) => {
    inMemoryToken = token;
    if (token) {
      try {
        sessionStorage.setItem("authorization", token);
      } catch (e) {}
    } else {
      try {
        sessionStorage.removeItem("authorization");
      } catch (e) {}
    }
    tokenChangeListeners.forEach((listener) => listener(token));
  },

  getToken: (): string | null => {
    if (inMemoryToken) {
      return inMemoryToken;
    }
    try {
      const sessionTok = sessionStorage.getItem("authorization");
      if (sessionTok && sessionTok !== "null" && sessionTok !== "undefined") {
        inMemoryToken = sessionTok;
        return sessionTok;
      }
    } catch (e) {}
    return null;
  },

  clearToken: () => {
    inMemoryToken = null;
    try {
      sessionStorage.removeItem("authorization");
      localStorage.removeItem("authorization");
    } catch (e) {}
    tokenChangeListeners.forEach((listener) => listener(null));
  },

  subscribe: (listener: (token: string | null) => void) => {
    tokenChangeListeners.push(listener);
    return () => {
      tokenChangeListeners = tokenChangeListeners.filter((l) => l !== listener);
    };
  },
};
